import { Injectable } from '@angular/core';

@Injectable()
export class AlertmessagesService {

  constructor() { }


}



// WEBPACK FOOTER //
// C:/Users/USer/Interviewfeedback/src/app/alertmessages.service.ts